export const APP_URLS = {
  HOME: '/home',
  LANDING: '/landing',
  SEARCH: '/search',
  SCHOOL: '/school',
  ROOT: '/',
  FORM: '/form',
  DIFORM:'/diform',
  OPERATION_FORM: '/operation-form',
  PROFILE: '/profile',
  PROFILE_EDIT_FORM: '/profile-edit-form',
  DIHOME: '/dihome',
  DIPROFILE: '/diprofile',
  DIPROFILE_EDIT: '/diprofile-edit',
  REPORTS: '/reports'
};
